// src/pages/battle/components/SquadStatus.jsx
import React from 'react';
import { Users } from 'lucide-react';
import { getColorClasses } from '../../themeConfig';
import { getHealthTextColor, calculateHealthPercentage, getHealthBarBgColor } from '../Battlemap.utils';

const SquadStatus = ({ soldiers, primaryColor, alertColor }) => {
  return (
    <div className={`bg-gray-800 border ${getColorClasses(primaryColor, 'border')} rounded-lg p-4`}>
      <div className="flex items-center gap-2 mb-4">
        <Users className={getColorClasses(primaryColor)} size={20} />
        <h2 className="font-bold text-lg">YOUR SQUAD</h2>
      </div>
      {soldiers.map(s => (
        <div key={s.id} className="bg-gray-900/50 rounded p-3 mb-2">
          <p className="font-bold text-sm mb-1">{s.name}</p>
          <p className="text-xs text-gray-400 mb-2">{s.rank} - {s.classId}</p>
          <div className="space-y-1">
            <div className="flex items-center justify-between text-xs">
              <span className="text-gray-400">HP</span>
              <span className={getHealthTextColor(s.hp, getColorClasses(alertColor))}>
                {s.hp}/{s.maxHp}
              </span>
            </div>
            <div className="w-full bg-gray-700 rounded-full h-2">
              <div 
                className={`h-2 rounded-full ${getHealthBarBgColor(s.hp, alertColor)}`}
                style={{ width: `${calculateHealthPercentage(s.hp, s.maxHp)}%` }}
              />
            </div>
            <div className="flex items-center justify-between text-xs mt-2">
              <span className="text-gray-400">AP</span>
              <span className={getColorClasses(primaryColor)}>{s.ap}/{s.maxAp}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SquadStatus;